import { KEYS } from '@constants'
import {
  GlobalSearchTabs,
  ProductDetailTabs,
  SupplierDetailTabs,
  UserListTabs,
  SystemTabs,
  TagDetailTabs,
} from '@tabs'
import { LABELS } from './labels.constants'

export const PRODUCT_DETAIL_TABS = [
  {
    id: KEYS.PRODUCT_INFORMATION,
    label: LABELS.PRODUCT_INFORMATION,
    component: ProductDetailTabs.ProductInformationTab,
    disabled: false,
  },
  {
    id: KEYS.PRODUCT_LOCATION,
    label: LABELS.LOCATION,
    component: ProductDetailTabs.ProductLocationTab,
    disabled: false,
  },
  {
    id: KEYS.PRODUCT_AVAILABILITY,
    label: LABELS.AVAILABILITY,
    component: ProductDetailTabs.ProductAvailabilityTab,
    disabled: false
  },
  {
    id: KEYS.PRODUCT_WEBSHOP_EXTRAS,
    label: LABELS.PRODUCT_WEBSHOP_EXTRAS,
    component: ProductDetailTabs.ProductExtrasTab,
    disabled: false,
  },
]
export const SUPPLIER_DETAIL_TABS = [
  {
    id: KEYS.SUPPLIER_INFORMATION,
    label: LABELS.SUPPLIER_INFORMATION,
    component: SupplierDetailTabs.SupplierInformationTab,
    disabled: false,
  },
  {
    id: KEYS.SUPPLIER_CONTACTS,
    label: LABELS.CONTACTS,
    component: SupplierDetailTabs.SupplierContactsTab,
    disabled: false,
  },
]

export const GLOBAL_SEARCH_TABS = [
  {
    id: KEYS.ALL,
    label: LABELS.ALL,
    component: GlobalSearchTabs.GlobalSearchAllTab,
    disabled: false,
  },
  {
    id: KEYS.WEEK_ORDER,
    label: LABELS.WEEK_ORDERS,
    component: GlobalSearchTabs.GlobalSearchWeekOrdersTab,
    disabled: false,
  },
  {
    id: KEYS.CUSTOMER,
    label: LABELS.CUSTOMERS,
    component: GlobalSearchTabs.GlobalSearchCustomersTab,
    disabled: false,
  },
  {
    id: KEYS.TEMPLATE,
    label: LABELS.TEMPLATES,
    component: GlobalSearchTabs.GlobalSearchTemplatesTab,
    disabled: false,
  },
]

export const USERS_TABS = [
  {
    id: KEYS.EMPLOYEES,
    label: LABELS.EMPLOYEES,
    component: UserListTabs.EmployeeUserListTab,
    disabled: false,
  },
  {
    id: KEYS.CUSTOMERS,
    label: LABELS.CUSTOMERS,
    component: UserListTabs.CustomerUserListTab,
    disabled: false,
  }
]

export const SYSTEM_TABS = [
  {
    id: 'job_batches',
    label: 'Job Batches',
    component: SystemTabs.SystemJobBatchesTab,
    disabled: false,
  },
  {
    id: 'jobs',
    label: 'Jobs',
    component: SystemTabs.SystemJobsTab,
    disabled: false,
  },
  {
    id: 'failed_jobs',
    label: 'Failed Jobs',
    component: SystemTabs.SystemFailedJobsTab,
    disabled: false,
  },
]

export const TAG_DETAIL_TABS = [
  {
    id: KEYS.TAG_INFORMATION,
    label: LABELS.TAG_INFORMATION,
    component: TagDetailTabs.TagInformationTab,
    disabled: false,
  },
  {
    id: KEYS.TAG_RELATED_PRODUCTS,
    label: LABELS.RELATED_PRODUCTS,
    component: TagDetailTabs.TagRelatedProductsTab,
    disabled: false,
  },
  {
    id: KEYS.TAG_TARGETED_PRODUCTS,
    label: LABELS.TARGETED_PRODUCTS,
    component: TagDetailTabs.TagTargetedProductsTab,
    disabled: false,
  },
  {
    id: KEYS.TAG_RELATED_CUSTOMERS,
    label: LABELS.RELATED_CUSTOMERS,
    component: TagDetailTabs.TagRelatedCustomersTab,
    disabled: false,
  },
]
